// 公共常量 枚举

// 交易类型
export const TRADE_TYPE = {
  RECHARGE: 1, // 充值
  WITHDRAW: 2, // 提现
  TRANSFER: 3, // 转账
  CONSUME: 4 // 消费
}

// 交易类型对应文案
export const DES_TRADE_TYPE = {
  [TRADE_TYPE.RECHARGE]: 'topup_option', // 充值
  [TRADE_TYPE.WITHDRAW]: 'withdraw_option', // 提现
  [TRADE_TYPE.TRANSFER]: 'transfer_option', // 转账
  [TRADE_TYPE.CONSUME]: 'payment_option' // 消费
}

// 收款方账户类型
export const ACCOUNT_TYPE = {
  WALLET_TYPE: 0, // 钱包
  BANK_ACCOUNT: 1, // 银行账户
  BANK_CARD: 2 // 银行卡号
}

// 银行编号
export const BANK_NO = {
  krungsri: 100008,
  SCB: 100001,
  BOT: 100000,
  Kbank: 100002,
  BBL: 100003,
  KTB: 100004,
  TMB: 100005,
  GSB: 100006,
  BAAC: 100007,
  BAY: 100008,
  TBANK: 100009,
  UOB: 100010,
  CIMB: 100011,
  LHB: 100012,
  KNB: 100013,
  EXIM: 100014,
  SCT: 100015,
  TISCO: 100016,
  GHB: 100017,
  KK: 100018,
  BOC: 100901,
  ICBC: 100902,
  BAC: 100921,
  Citibank: 100922,
  HSBC: 100941,
  FlashPay: 999999
}

// 三种银行支付得方式 枚举
export const BANK_PAYMENT_TYPE = Object.freeze({
  IBanking: 'IBanking',
  MBanking: 'MBanking',
  ATM: 'ATM'
})

// 低级高级枚举
export const VERIFIED_STATUS = {
  LOW: 2,
  HIGH: 4
}
// 接口错误代码code
export const ERROR_REQ_CODE = {
  passError: 200037, // 交易密码错误
  faceFaliedError: 500304, // 活体五次错误
  TOKEN_ERROR: 500102, // token失效
  TOKEN_TIMEOUT: 500411, // token超时
  LOGIN_AGAIN: 500101, // 重复登录
  FACE_FAILED: 500303, // 面部识别失败
  SECOND_FAILED: 500310, // 面部识别两次报错
  ACCOUNT_STATUS_ERROR: 500002, // 账户状态异常
  USER_ONLINE: 500311 // 开通用户已达上线
}

// 交易状态
export const TRANSACTION_STATUS = {
  wait: 0, // 等待交易
  pend: 1, // 银行受理
  pending: 2, // 银行处理中
  success: 3, // 交易成功
  fail: 4, // 交易失败
  timeout: 5 // 超时交易关闭
}

// 公共事业 交易状态枚举
export const UTILITIES_ORDER_STATUS = {
  wait: 0, // 初始状态
  success: 1, // 成功
  processing: 2, // 处理中
  fail: 3 // 交易失败
}

export const TRADE_TITLE = {
  TopUpAdmin: 14001, // 充值页面
  Withdraw: 14002, // 提现页面
  TransferToAccount: 14003, // 手机号和钱包账户转账
  TransferToBank: 14003 // 银行账户转账
}

// 银行组织编号
export const BANK_ORG = {
  master: '364',
  jcb: '363',
  visa: '331'
}

// 激活以及实名认证进度
export const confirmStep = {
  FIRST: 1, //  "低级实名开始（未低级，未激活）"
  SECOND: 2, // "设置支付密码（低级实名，未激活）"
  THIRD: 3 // "高级实名（未高级,已激活）"
}

// 客户端区别
export const CLIENT = {
  FLP_USER_ACCESS_FLAG: 1 // 快递客户端
}

export const FLP_USER_ACCESS_FLAG_KEY = 'FLP-USER-ACCESS-FLAG'

export const MOBILE_PHONE_MAX_LENGTH = 13
export const MOBILE_PHONE_MIN_LENGTH = 8

// 判断是不是设置临时密码
export const TEMP_PASSWORD_CODE = {
  temp: 1
}
